module.exports = __webpack_public_path__ + "public/images/privacy-checkbox.d2656d49a1f5e4e8ed34fa07ceaca4c8.svg";